import axios from 'axios'
import {
  getAccessToken,
  getRefreshToken,
  setAccessToken,
  setRefreshToken,
} from '../shared-constants/localstorage'

import { updateAccessToken } from './api'
import { ErrorHandler } from './error-handler'
import { logout } from '../shared-utils/logout'

export const APISetter = () => {  
  axios.interceptors.response.use(
    (response) => {
      if (response?.data?.data) return response?.data?.data
      else return response.data
    },

    async (error) => {
      const config = error.config;
      
      if (error?.response?.status === 401) {
        if (config._retry) { 
          throw new axios.Cancel('refresh limit exceeded');
        }
        config._retry = true;
        const refreshToken = getRefreshToken()
        if(!refreshToken) throw new Error("refresh token doesn't exist");
        const response = await updateAccessToken({ refreshToken }).catch(
          (error) => logout(),
        )
        setRefreshToken(response.refreshToken)
        setAccessToken(response.accessToken)
        axios.defaults.headers.common['Authorization'] =
          'Bearer ' + response.accessToken
        return axios(config)
      }
      ErrorHandler(error)
      return Promise.reject(error)
    },
  )

  axios.interceptors.request.use(
    (request) => {
      const token = getAccessToken()
      request.headers.Authorization = token ? 'Bearer ' + token : undefined
      request.headers['platform'] = 'pwa'
      const cancelTokenSource = axios.CancelToken.source()
      request.cancelToken = cancelTokenSource.token
      return request
    },
    (error) => {
      return Promise.reject(error)
    },
  )
}
